const formUpdate = (event) => {
   const allOptions = [...event.target.parentElement.querySelectorAll('[data-action="formUpdate"]')];
   const activeClass = 'form-update-option--active';
   const container = event.target.offsetParent.offsetParent;
   const allForms = [...container.querySelectorAll('[data-contact-block-form]')];
   const activeFormReference = event.target.innerText;
   const paragraphContainer = container.querySelector('[data-multiple-contact-paras]');


   if (paragraphContainer) {
      const paragraphHiddenClass = 'contact-form__para--hidden';
      const allParagraphs = [...paragraphContainer.querySelectorAll('[data-contact-para]')];
      allParagraphs.forEach(para => {
         if (para.dataset.contactPara === activeFormReference) {
            para.classList.remove(paragraphHiddenClass);
         } else {
            para.classList.add(paragraphHiddenClass);
         }
      });
   }

   allOptions.forEach(option => {
      option.classList.remove(activeClass);
   });
   event.target.classList.add(activeClass);

   allForms.forEach(form => {
      if (form.dataset.contactBlockForm === activeFormReference) {
         form.classList.remove('hidden');
      } else {
         form.classList.add('hidden');
      }
   });
   
};

export default formUpdate;